import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table";
import { selectOrderPolicyListItems } from "../../../../../redux/order-policies/selector";
import { orderPolicies } from "../../../../../redux/order-policies/action";




const OrderPolicies = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const [pageData, setPageData] = useState(1)

    const itemsData = useSelector(selectOrderPolicyListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
          { field: 'Name', headerName: 'Name', sortable: true, filter: false, isEdit: true },
      { field: 'StartDateUtc', headerName: 'Start Date', isDateValueFormat:true, },
      { field: 'EndDateUtc', headerName: 'End Date', isDateValueFormat:true, },
      
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      
      const handleDelete=(data: any)=>{
        dispatch(orderPolicies.delete({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/smart-order-policy/order-policies/delete`,
          entity: 'orderPolicies',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
          dispatch(orderPolicies.list({
              url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/smart-order-policy/order-policies/list`,
              entity: 'orderPolicies',
              jsonData: { "PageNumber": pageData,
              "PageSize": 10,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
      const additionButtons: any = [
        {
          name: 'Add OrderPolicy',
          callback: () => handleAdd(),
        }
      ];
      const fetchOrderPolicies=()=>{
        dispatch(orderPolicies.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/policy/smart-order-policy/order-policies/list`,entity:'orderPolicies',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchOrderPolicies()
	}, [pageData])

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
		<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
    paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="OrderPolicys"/>
     
  }
  </>
	);
};

export default OrderPolicies;


